import React from "react";
import footerLogo from "../assests/Footer_logo.png";
import SektchLogo3 from "../assests/SektchLogo4.png";
import { IoLogoFacebook } from "react-icons/io";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaGooglePlusG } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";
import { IoLogoRss } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FaHome } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";

export default function Footer() {
  const handleGetInTouch = () => {
    const getInTouchSection = document.getElementById("contact_us");
    if (getInTouchSection) {
      getInTouchSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  const navigate = useNavigate();
  return (
    <div className="footerMain" id="consulting">
      <div className="footerMainContainer">
        <div className="w-full md:w-3/4">
          <div className="w-full flex md:justify-start justify-center">
            <img className="w-48" src={SektchLogo3} alt="" srcset="" />
          </div>
        </div>
        <div className="w-full md:w-2/4 ">
          <div className="footerMainContainer2Child pb-5">
            <div className="footerMainContainer2Child1 flex items-center gap-2">
              <FaPhoneAlt className="footerIcons2" />
              <p>0304 1115555</p>
            </div>
            <div className="footerMainContainer2Child1 flex items-center gap-2">
              <IoMail className="footerIcons2" />{" "}
              <p> contact@zulqarnainmahmood.com</p>
            </div>
            <div className="footerMainContainer2Child1 flex items-center gap-2">
              <FaHome className="footerIcons2" />
              <p>JV Lands, 17 CCA, DHA Phase 8 - Ex Park View Lahore</p>
            </div>
          </div>

          <div className="footerMainContainer2Child3">
            <div className="footerMainContainer2Child3Text">Social Media :</div>
            <div className="w-auto">
              <a href="https://www.facebook.com/profile.php?id=100074351302557">
                <IoLogoFacebook className="footerIcons1" />
              </a>
            </div>
            {/* <div className="w-auto">
              <FaTwitter className="footerIcons2" />
            </div> */}
            <div className="w-auto">
              <a href="https://www.youtube.com/@ZulqarnainPropertyExpert">
                <FaYoutube className="footerIcons4" />
              </a>
            </div>
            <div className="w-auto">
              <a href="https://www.tiktok.com/@zulqarnainmahmood">
                <FaTiktok className="footerIcons2" />
              </a>
            </div>

            <div className="w-auto">
              {/* <FaLinkedinIn className="footerIcons3" /> */}

              <a href="www.linkedin.com/in/zulqarnainmahmood">
                <FaLinkedinIn className="footerIcons3" />
              </a>
            </div>
            {/* <div className="w-auto">
              <a href="https://www.instagram.com/am_global.ae?igsh=Nnp5OXFybnBmb2V6&utm_source=qr">
                <FaInstagram className="footerIcons5" />
              </a>
            </div> */}
            {/* <div className="w-auto">
              <FaGooglePlusG className="footerIcons6" />
            </div>
            <div className="w-auto">
              <FaPinterest className="footerIcons7" />
            </div>
            <div>
              <IoLogoRss className="footerIcons8" />
            </div> */}
          </div>
        </div>
      </div>
      {/* <div className="footerMainBottom flex flex-col  lg:flex-row justify-between">
        <div className="pb-5 lg:pb-0 w-full lg:w-1/2 flex justify-center text-center sm:justify-between gap-2 md:gap-5 text-white md:text-sm text-[8px]">
          <div onClick={() => navigate("/about-us")} className="cursor-pointer">
            About us
          </div>
          <div
            onClick={() => {
              navigate("/");
              handleGetInTouch();
            }}
            className="cursor-pointer"
          >
            Contact us
          </div>
          <div>Help</div>
          <div>Privacy Policy</div>
          <div>Disclaimer</div>
        </div>
        <div className="footerMainBottomChild2">
          Copyright © 2024 • AM GLOBAL
        </div>
      </div> */}
    </div>
  );
}
